import {
  faCheck,
  faClock,
  faEye,
  faHandshake,
  faPen,
  faTrash,
  faTrashCan,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Component } from "react";
import { showConfirmationModal } from "../redux-state/features/global-state/globalStateSlice";
import { connect } from "react-redux";
import axios from "axios";
import { showSuccess, showError } from "../utils/notifications";
import urls from "../urls";
import {
  setShowOrderModal,
  addOrderItems,
  setHideOrderModal,
  updateOrderStatus,
  deleteItemFromOrders,
} from "../redux-state/features/orderState";
import {
  setsMaintenanceRequestText,
  showViewMaintenanceRequestModal,
} from "../redux-state/features/maintenance/maintenanceSlice";
class ApplicationTableItem extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.status = {
      pending: "قيد المعالجة",
      approved: " تمّ قبول الطلب في إنتظار تسليمه",
      rejected: "تمّ رفض الطلب",
      served: "تمّ تأكيد إستلام الطلب من قبل المستخدم",
      confirmed: "تمّ تسليم الطلب في إنتظار تأكيد المستخدم",
    };
    this.icon_name = {
      pending: faClock,
      approved: faCheck,
      rejected: faXmark,
      served: faHandshake,
    };
  }
  confirmOrder = (orderId, applicationType) => {
    axios
      .put(urls.confirmOrder, {
        data: { orderId, orderStatus: "approved", applicationType },
      })
      .then((res) => {
        showSuccess("تم تأكيد قبول الطلب ");
        this.props.updateOrderStatus({
          orderId,
          updatedProperties: { status: "approved" },
          applicationType,
        });
      })
      .catch((err) => {
        showError("لم يتم تأكيد  قبول الطلب ");
      });
  };
  editOrder = (orderId, orderItems) => {
    console.log(orderItems);
    // const orderItems_ = JSON.parse(orderItems);
    // const orderItems_ = orderItems;
    const orderItems_ =
      typeof orderItems === "string" ? JSON.parse(orderItems) : orderItems;

    this.props.addOrderItems(
      orderItems_.map((obj) => ({
        ...obj,
        orderItem: obj.item_description,
        orderId,
        quantity: obj.ordered_quantity,
      }))
    );
    this.props.setShowOrderModal();
  };
  handleRejection = (orderId, applicationType) => {
    axios
      .put(urls.confirmOrder, {
        data: { orderId, orderStatus: "rejected", applicationType },
      })
      .then((res) => {
        showSuccess("تم تأكيد رفض  الطلب ");
        this.props.updateOrderStatus({
          orderId,
          updatedProperties: { status: "rejected" },
          applicationType,
        });
      })
      .catch((err) => {
        showError("لم يتم تأكيد  رفض  الطلب ");
      });
  };
  deleteOrder = (orderId, applicationType) => {
    axios
      .delete(urls.deleteOrder(applicationType, orderId))
      .then((res) => {
        showSuccess("تم حذف  الطلب ");
        this.props.deleteItemFromOrders(orderId);
      })
      .catch((err) => {
        showError("لم يتم حذف  الطلب ");
      });
  };
  handleViewServiceRequest = (requestText) => {
    this.props.setsMaintenanceRequestText(requestText);
    this.props.showViewMaintenanceRequestModal();
  };
  render() {
    const {
      email,
      status,
      user,
      applicationType,
      date,
      orderId,
      orderItems,
      userType,
    } = this.props.obj;
    const applicationType_ =
      applicationType === "service" ? " صيانة" : "مستلزمات";

    const status_ = this.status[status];

    return (
      <tr
        className={`  ${status === "rejected" ? " p-1 alert-danger " : ""}`}
        style={{ fontSize: "12px" }}
      >
        <td>{this.props.orderNumber}</td>
        <td>{user}</td>
        <td> {email}</td>
        <td>{applicationType_}</td>
        <td>{date}</td>
        <td>
          <div>
            <FontAwesomeIcon
              className={"mx-2 "}
              icon={this.icon_name[status]}
              size="lg"
            />
            <span>{status_}</span>
          </div>
        </td>
        <td style={{ width: "25%" }}>
          <div className="d-flex justify-content-between">
            {applicationType === "service" && (
              <button
                className="btn  border border-1 "
                onClick={() => this.handleViewServiceRequest(orderItems)}
              >
                <FontAwesomeIcon icon={faEye} title="معاينة" size="lg" />
                <span className="mx-1" style={{ fontSize: "9px" }}>
                  معاينة
                </span>
              </button>
            )}
            {["pending", "rejected"].includes(status) && (
              <button
                className="btn  btn-outline-success "
                onClick={() => this.confirmOrder(orderId, applicationType)}
              >
                <FontAwesomeIcon
                  className="mx-2"
                  icon={faCheck}
                  title="قبول الطلب"
                />
                قبول
              </button>
            )}
            {!["served", "rejected", "confirmed"].includes(status) && (
              <button
                className="btn btn-outline-danger"
                onClick={() => this.handleRejection(orderId, applicationType)}
              >
                <FontAwesomeIcon icon={faXmark} title="رفض الطلب" size="lg" />
                <span className="mx-2"> رفض </span>
              </button>
            )}
            {status === "pending" && applicationType != "service" && (
              <button
                className="btn  border border-1 text-dark"
                title="تعديل الطلب"
                onClick={() => this.editOrder(orderId, orderItems)}
              >
                <FontAwesomeIcon icon={faPen} size="lg" />
              </button>
            )}
            {["pending", "rejected", "served"].includes(status) && (
              <button
                className="btn  border border-1 text-danger"
                title="حذف الطلب "
                onClick={() => this.deleteOrder(orderId, applicationType)}
              >
                <FontAwesomeIcon icon={faTrashCan} size="lg" />
              </button>
            )}
          </div>
        </td>
      </tr>
    );
  }
}

const mapDispatchToProps = {
  showConfirmationModal,
  setShowOrderModal,
  addOrderItems,
  updateOrderStatus,
  deleteItemFromOrders,
  setsMaintenanceRequestText,
  showViewMaintenanceRequestModal,
};
const mapStateToProps = (state) => ({ userType: state.userState.userType });
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationTableItem);
